<!-- 证照阈值管理 -->
<template>
    <div class='page_content'>
        <div class="page_content_top">
            <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getDataList" :showRefresh="true" :buttonFlag="false"></v-button>

        </div>
        <div class="page_content_center">
            <el-table stripe :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum" border style="width: 100%" highlight-current-row
                size="mini">
                <el-table-column align="center" label="选择操作" width="80">
                    <template slot-scope="scope">
                        <el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini">
                            <i class="el-icon-thumb"></i>
                        </el-radio>
                    </template>
                </el-table-column>
                <el-table-column align="center" show-overflow-tooltip prop="goodsNum" label="商品预警阈值"></el-table-column>
     
               <el-table-column align="center" show-overflow-tooltip prop="supplierNum" label="供货商证照预警阈值"></el-table-column>
                <el-table-column align="center" show-overflow-tooltip prop="customerNum" label="客户证照预警阈值"></el-table-column>
                   <el-table-column align="center" show-overflow-tooltip prop="salesNum" label="委托书预警阈值"></el-table-column>
                <el-table-column align="center" show-overflow-tooltip prop="receiptNum" label="回执时间阈值"></el-table-column>
                <el-table-column align="center" show-overflow-tooltip prop="expiNum1" label="近效期预警1"></el-table-column>
                <el-table-column align="center" show-overflow-tooltip prop="expiNum2" label="近效期预警2"></el-table-column>
                <el-table-column align="center" show-overflow-tooltip prop="expiNum3" label="近效期预警3"></el-table-column>
            
               
            </el-table>
        </div>
      
        <el-drawer :close-on-press-escape="true" :visible.sync="dialogVisible" :with-header="false"
            append-to-bodycustom-class="drawer_box" direction="ltr" size="40%">
            <licenseWarnDataAction v-if="dialogVisible" ref="licenseWarnDataAction" @drawerCancel="drawerCancel"
                :actionData="actionData"></licenseWarnDataAction>
        </el-drawer>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import licenseWarnDataAction from "@/components/licenseWarnDataAction.vue";

export default {
    //import引入的组件需要注入到对象中才能使用
    components: {licenseWarnDataAction},
    data() {
        //这里存放数据
        return {
            tableHeight:0,
            returnData: {
                pages: 0, // 总页数
                total: 0, // 总条数
                pageNum: 0, // 当前页数
                list: []
            },
            buttonList: [],
            pageShowData: [],
            selectedDataIndex: 0,
            actionData: {},
            dialogVisible: false,
            sendDataInfo: {
                customerNum: '', //	客户证照预警阈值
                goodsNum: '', //	商品证照阈值
                receiptNum: '', //	回执时间阈值
                salesNum: '', //对方业务员证照阈值
                supplierNum: '', //	供货商证照预警阈值
                warId: '', //	ID
                expiNum1: '', //	近效期预警1
                expiNum2: '', //	近效期预警2
                expiNum3: '', //	近效期预警3
            },

        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        // 动作集合
        actionSet(actionData) {
            switch (actionData.actionType) {
                case 0:

                    this.actionData = {
                        cate: 0,
                        formData: '',
                        oldData: '',
                        orderId: '',
                        printSouce: '',
                        printJurId: ''
                    }
                    this.dialogVisible = true
                    break;
                case 1:
                    var dataInfo = this.returnData.list[this.selectedDataIndex]
                    if (!dataInfo) {
                        this.$message({
                            message: '请先选中要操作的数据',
                            type: 'error'
                        });
                        return false
                    }
                    for (const key in this.sendDataInfo) {
                        this.sendDataInfo[key] = dataInfo[key]
                    }
                    this.actionData = {
                        cate: 1,
                        formData: '',
                        oldData: dataInfo,
                        orderId: '',
                        printSouce: '',
                        printJurId: ''
                    }
                    this.dialogVisible = true
                    break;
                case 2:
                    this.delDataAction()
                    break;
                case 3:
                    this.submitDataAction()
                    break;

            }
        },
        //确认新增
        sendDataAction(formName1) {
            this.$refs[formName1].validate((valid) => {
                if (valid) {
                    // console.log('send', this.sendDataInfo)
                    this.sub(formName1)
                } else {
                    this.$message({
                        message: '请完善必填信息',
                        type: 'error'
                    })
                    return false;
                }
            })
        },
        async sub(formName1) {
            var responseData
            responseData = await this.$http.licenseWarnUpdateLicenseWarn(this.sendDataInfo)
            if (responseData.status == 200) {
                this.init()
                this.$message({
                    message: '操作成功',
                    type: 'success'
                });
                this.$refs[formName1].resetFields()

            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },
        drawerCancel() {
            this.dialogVisible = false
            this.getDataList()
        },
        //取消
        initActionBox(formName1) {
            this.$confirm('确定取消修改吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.init()
                this.$refs[formName1].resetFields()
                this.dialogVisible = false
            }).catch(() => { });
        },
        //初始化
        init() {
            for (let key in this.sendDataInfo) {
                if (key == 'reiDate') {
                    this.sendDataInfo[key] = this.$moment().valueOf()
                } else {
                    this.sendDataInfo[key] = ''
                }
            }
        },

        // 获取数据列表
        async getDataList() {
            let responseData = await this.$http.getLicenseWarnQueryAll()
            if (responseData.status == 200) {
                this.returnData.list = responseData.result
                this.selectedDataIndex = 0
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },
        async getButtonList() {
            this.buttonList = await this.$common.getActionButton()
        },


    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getDataList()
        this.getButtonList()
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() {this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style scoped>
.table_content_tag {
    margin-right: 1rem;
}

.el-tabs--border-card_new {
    height: 85vh;
    overflow-y: scroll;
}

.el-drawer {
    outline: none;
}

.baseForm .el-row {
    margin: 20px 0px;
    flex-direction: row;
}

</style>
